import { Tab, Tabs } from "@mui/material";
import { Outlet, To, useLocation, useNavigate } from "react-router";
import NewCellDialog from "./NewCellDialog";
import { useState } from "react";
import { selectProfileBuilderFieldById } from "redux/slices/lensEditor";
import { useAppSelector } from "redux/hooks";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { DropdownButton } from "components/DropdownButton";
import { CellPreset } from "./types";

const AddCellOptions = [
  {
    value: CellPreset.Custom,
    title: "Add Custom Cell",
  },
  {
    value: CellPreset.SSN,
    title: "SSN (XXX-XX-XXXX)",
  },
  {
    value: CellPreset.BMI,
    title: "Body Mass Index (BMI)",
  },
  {
    value: CellPreset.PacksPerDay,
    title: "Packs of Cigarettes Smoked Per Day",
  },
];

const ProfileBuilderFieldWrapper = () => {
  const navigate = useNavigate();
  const { fieldId } = useParamNumbers(["fieldId"]);
  const location = useLocation();
  const [showNewCellDialog, setShowNewCellDialog] = useState<boolean>(false);
  const [selectedPreset, setSelectedPreset] = useState<CellPreset>(CellPreset.Custom);
  const selectedField = useAppSelector((state) => selectProfileBuilderFieldById(state, fieldId));

  const value = location.pathname.split("/").pop();
  const handleChange = (_evt, newValue: To) => {
    navigate(newValue);
  };
  const onSelect = (preset: CellPreset) => {
    setShowNewCellDialog(true);
    setSelectedPreset(preset);
  };
  return (
    <div className="bg-white rounded-md shadow p-4">
      {showNewCellDialog && selectedField && (
        <NewCellDialog
          open={showNewCellDialog}
          preset={selectedPreset}
          close={() => setShowNewCellDialog(false)}
          field={selectedField}
          rank={selectedField.cells.length}
        />
      )}
      <div className="flex items-center justify-between">
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Cells" value="cells" />
          <Tab label="Settings" value="settings" />
        </Tabs>
        {value === "cells" && (
          <DropdownButton title="Add Cell" options={AddCellOptions} onSelect={onSelect} variant="contained" />
        )}
      </div>

      <Outlet />
    </div>
  );
};

export default ProfileBuilderFieldWrapper;
